<template>
  <div class="container">
    <el-tabs v-model="activeName">
      <el-tab-pane label="提醒" name="first">
            <leftMessage></leftMessage>
      </el-tab-pane>
      <el-tab-pane label="互动" name="second">
        <rightMess></rightMess>
        <!-- <div style="display: flex; justify-content: space-between">
          <div style="font-size: 20px">收到互动消息</div>
          <div style="width: 100px; height: 25px">
            <img
              src="../../assets/icon/删 除 .png"
              alt=""
              style="margin-right: 8px"
            />
            <span style="position: absolute">全部删除</span>
          </div>
        </div>
        <div class="detail" v-for="(item, i) in replyList" :key="i">
          <div class="logo">
            <img src="../../assets/icon/组 74.png" alt="" />
          </div>
          <div class="details">
            <div class="detailsTitle"></div>
            <span style="font-size: 20px"
              ><strong>{{ item.title }}</strong></span
            >
            <span style="color: #9f9f9f; margin-left: 15px">{{
              timestampToTime(item.createTime)
            }}</span>
            <img
              src="../../assets/icon/X.png"
              alt=""
              style="float: right; margin: 5px"
            />
          </div>
          <div style="margin-top: 20px; width: 970px">
            <span>{{ item.advise }}</span>
          </div>
          <div class="btn">
            <div
              style="
                width: 80px;
                height: 26px;
                border: 1px solid #a0a0a0;
                border-radius: 12px;
                text-align: center;
              "
            >
              <span
                style="color: #a0a0a0; cursor: pointer"
                v-if="more === true"
                @click="more = false"
                ><img src="../../assets/icon/展开 (1).png" alt="" />展开</span
              >
              <span
                style="color: #a0a0a0; cursor: pointer"
                v-if="more === false"
                @click="more = true"
                ><img src="../../assets/icon/展开 (2).png" alt="" />收起</span
              >
            </div>
          </div>
        </div>
        <div class="page">
          <el-pagination
            background
            :current-page.sync="currentPage"
            @current-change="CurrentChange"
            layout="prev, pager, next"
            :total="10"
          >
          </el-pagination>
        </div> -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import api from "../../api";
import cookie from "@/api/cookie";
import leftMessage from './leftMessage.vue'
import rightMess from './rigMessage.vue'

export default {
  components:{
    leftMessage,
    rightMess
  },
  data() {
    return {
      activeName: "first",
      more: false,
      adviseList: [],
      replyList: [],
      currentPage: 1,
      totalPage: 100,
      num123: 123,
    };
  },
  methods: {
    timestampToTime(timestamp) {
      let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "年";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "月";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "日";
      return Y + M + D;
    },
    CurrentChange() {
      api
        .getAdvise(cookie.getCookie("userId"), this.currentPage, 15)
        .then((res) => {
          // console.log(res.data.list)
          this.adviseList = [];
          this.replyList = [];
          res.data.list.forEach((itm) => {
            if (itm.adviceType == 1) {
              // this.adviseList=[]
              // console.log(itm)
            //   this.adviseList.push(itm);
            } else if (itm.adviceType == 2) {
              // this.replyList=[]
              this.replyList.push(itm);
            }
          });
        });
    },
    // 获取管理员通知
    getMessage(){
        api
        .getmsgsList({
            page:1,
            size:15
        })
        .then((res) => {
          console.log(res.data.list,'我读取到了？？')
          this.adviseList = res.data.list
        });
    }
  },
  mounted() {
    // this.CurrentChange();
    // this.getMessage();
    // api.getAdvise(cookie.getCookie("userId"), 0, 0).then((res) => {
    //   // this.totalPage=Math.ceil(res.data.list.length/5*10)
    //   // console.log(this.totalPage)
    //   // console.log(res.data.list.length/5*10)
    //   if (Number((res.data.list.length / 5) * 10) <= 20) {
    //     this.totalPage = 10;
    //   } else if (
    //     Number((res.data.list.length / 5) * 10) > 20 &&
    //     Number((res.data.list.length / 5) * 10) <= 40
    //   ) {
    //     this.totalPage = 20;
    //     console.log(111);
    //   } else if (
    //     Number((res.data.list.length / 5) * 10) > 40 &&
    //     Number((res.data.list.length / 5) * 10) <= 60
    //   ) {
    //     this.totalPage = 30;
    //   }
    // });
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: 20px auto 0;
  padding: 20px;
  background: #ffffff;
  min-height: 800px;

  .el-tabs__item.is-active {
    color: #dc2325;
  }

  .el-tabs__item:hover {
    color: #dc2325;
  }

  .el-tabs__active-bar {
    background: #dc2325;
  }
  .detail {
    width: 100%;
    height: 140px;
    margin-top: 30px;
    .logo {
      margin: 0 5px;
      float: left;
      width: 50px;
      height: 100%;
    }

    .btn {
      float: right;
      width: 80px;
      height: 100%;
      margin-right: 10px;
    }
  }
  .page {
    position: absolute;
    left: 390px;
    margin-top: 30px;
    width: 410px;
    .el-pagination {
      text-align: center;
    }
  }
}
</style>
